import * as types from "./../types";

const otpdata={
  request_id:""
}
const initState = {
  karzaOtpresponse: null,
  error: null,
};

const TelcoReducer = (state = initState, actions) => {
  switch (actions.type) {
    case types.SAVE_TELCO_OTP_GEN:
      return {
        ...state,
        karzaOtpresponse: {...otpdata, request_id:actions.payload.request_id},
      };
    case types.CLEAR_TELCO_OTP_RESPONSE:
      return {
        ...state,
        karzaOtpresponse: otpdata,
      };
    default:
      return state;
  }
};

export default TelcoReducer;
